module.exports = __webpack_public_path__ + "img/type3.341a0871.png";